/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-12-29 14:31:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-17 18:49:54
 */
import type { Reducer, Effect } from 'umi'
import { getBasicInfo } from '@/services/project/index'
import type { ICreateCompetitor, ProjectParams } from '@/typings/index'

interface StateType {
  similarProjects: ICreateCompetitor[]
  project?: ProjectParams
}

export interface LogModelType {
  namespace: string
  state: StateType
  effects: {
    fetchSimilarProjects: Effect
  }
  reducers: {
    saveSimilarProjects: Reducer<StateType>
    saveProject: Reducer<StateType>
  }
}

const IndexModel: LogModelType = {
  namespace: 'writeLog',

  state: {
    similarProjects: [],
    project: undefined
  },

  effects: {
    // 获取相似项目
    *fetchSimilarProjects({ payload }, { call, put }) {
      const res = yield call(getBasicInfo, {
        ...payload,
        is_need_competitor: 1
      })
      if (res.code === 0 && res.data) {
        yield put({
          type: 'saveSimilarProjects',
          payload: res.data.competitor_list || []
        })
        yield put({
          type: 'saveProject',
          payload: res.data.project || []
        })
      }
    }
  },

  reducers: {
    saveSimilarProjects(state, { payload }): any {
      return {
        ...state,
        similarProjects: payload
      }
    },
    saveProject(state, { payload }): any {
      return {
        ...state,
        project: payload
      }
    }
  }
}

export default IndexModel
